import VueI18n from 'vue-i18n';
import languages from './languages';
import store from '../store';

const onChangeListeners = [];

function onLocaleChange(locale) {
  onChangeListeners.forEach(listener => listener(locale));
}

export default {
  init(Vue) {
    Vue.use(VueI18n);
    this.vueI18n = new VueI18n({
      locale: this.defaultNavigatorLanguage,
      fallbackLocale: this.defaultLanguage,
      messages: languages,
    });
    const language = store.getters.getLanguage(this.vueI18n.locale);
    store.dispatch('setLanguage', language);
    // para testes da tradução no console - REMOVER
    window.SigmaI18n = this;
  },
  get i18n() {
    return this.vueI18n;
  },
  get locale() {
    return this.vueI18n.locale;
  },
  set locale(value) {
    this.vueI18n.locale = value;
    onLocaleChange(value);
  },
  get defaultLanguage() {
    return 'pt-BR';
  },
  get defaultNavigatorLanguage() {
    if (store.getters.getLanguage(window.navigator.language)) {
      return window.navigator.language;
    }

    return this.defaultLanguage;
  },
  addLocaleChangeListener(fn) {
    onChangeListeners.push(fn);
  },
};
